/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{decode as e}from"@keeex/bubble_babble";const t=/^(?<delim>[a-z])[aeiouy][bcdfghjklmnpqrstvwxz][aeiouy][bcdfghjklmnpqrstvwxz]-(?:[bcdfghjklmnpqrstvwxz][aeiouy][bcdfghjklmnpqrstvwxz][aeiouy][bcdfghjklmnpqrstvwxz]-){15}[bcdfghjklmnpqrstvwxz][aeiouy][bcdfghjklmnpqrstvwxz][aeiouy]\k<delim>$/u,r=(e,t)=>`${t}${e.substring(1,e.length-1)}${t}`;export const check=c=>{try{return t.test(c)&&32===e(r(c,"x")).byteLength}catch(e){return!1}};export const checkException=e=>{if(!check(e))throw new Error(`Invalid IDX: "${e}"`)};export const changeExtrem=(e,t="x")=>{if(1!==t.length)throw new Error(`Invalid extrems value "${t}"`);return checkException(e),r(e,t)};export const split=e=>(checkException(e),e.split("-"));export const head=(e,t,r=!1)=>t>=17?e:`${split(e).slice(0,t).join("-")}${r?"-…":""}`;